<script>
import TalkizyIntro from '@app/components/TalkizyIntro.vue';
import TalkizyConnectActions from '@app/components/TalkizyConnectActions.vue';

export default {
  name: 'TalkizyConnect',
  components: { TalkizyIntro, TalkizyConnectActions },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLoginLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <TalkizyIntro>
    <template #hero-actions>
      <TalkizyConnectActions
        :is-loading="isLoading"
        :is-login-loading="isLoginLoading"
        :disabled="disabled"
        @register="$emit('register')"
        @login="$emit('login')"
      />
    </template>
    <template #footer-actions>
      <TalkizyConnectActions
        :is-loading="isLoading"
        :is-login-loading="isLoginLoading"
        :disabled="disabled"
        @register="$emit('register')"
        @login="$emit('login')"
      />
    </template>
  </TalkizyIntro>
</template>
